function findUsersByIds(ids: string[], users: User[]): User[] {
  return users.filter((user: User) => {
    const target = ids.find(id => id === user.userId);
    return target !== undefined;
  });
}

export default findUsersByIds;
